import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as Cases from '../slices/casesSlice';
import NavMenu from './navmenu';
import NavBar from './navbar';
import TrackerChart from './trackerchart';
import icon_edit_chart from '../assets/edit-chart-icon.svg';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import { setTrackerChartOptions } from '../slices/casesSlice';
import { AnyAction } from '@reduxjs/toolkit';

type TrackerChartData = {
  [key: string]: {
    details: {
      tracker: {
        id: string;
        message: string;
        weight: number;
        value: string | null;
        stage: string;
        isVisible: boolean;
      }[];
    };
    options: {
      stage: string;
      items: {
        id: string;
        message: string;
        weight: number;
        value: string | null;
        stage: string;
        isVisible: boolean;
      }[];
    }[];
  };
};

const EditTrackerChart = () => {
  const cases = useAppSelector((state) => state.cases);
  const trackerChartOptions = JSON.parse(JSON.stringify(useAppSelector((state) => state.cases.trackerChartOptions)));
  const [trackerChartChangedIndex, setTrackerChartChangedIndex] = useState(0);
  const [trackerChartCaseType, setTrackerChartCaseType] = useState("Purchase");
  const dispatch = useAppDispatch();

  const [trackerChartData, setTrackerChartData] = useState<TrackerChartData>({
    Purchase: {
      details: {
        tracker: [
          {
            "id": "exchanged&completed",
            "message": "Exchanged&Completed",
            "weight": 12,
            "value": null,
            "stage": "Exchanged and Completed",
            "isVisible": true
          },
          {
            "id": "cclsent",
            "message": "Initial Paperwork Sent",
            "weight": 15,
            "value": "24/07/2023",
            "stage": "On-Boarding",
            "isVisible": true
          },
          {
            "id": "cclacceptable",
            "message": "Initial Paperwork Received",
            "weight": 15,
            "value": "04/12/2023",
            "stage": "On-Boarding",
            "isVisible": true
          },
          {
            "id": "fundsvalid",
            "message": "Client Search Monies Received",
            "weight": 18,
            "value": "04/12/2023",
            "stage": "On-Boarding",
            "isVisible": true
          },
          {
            "id": "contractsreceived",
            "message": "Draft Contracts Received",
            "weight": 15,
            "value": "04/12/2023",
            "stage": "Reporting",
            "isVisible": true
          },
          {
            "id": "searchesraised",
            "message": "Searches Requested",
            "weight": 12,
            "value": null,
            "stage": "Reporting",
            "isVisible": true
          },
          {
            "id": "searchesreceived",
            "message": "Searches Received",
            "weight": 12,
            "value": null,
            "stage": "Reporting",
            "isVisible": true
          },
          {
            "id": "reportontitle",
            "message": "Report Sent",
            "weight": 12,
            "value": null,
            "stage": "Reporting",
            "isVisible": true
          },
          {
            "id": "mortgagereceived",
            "message": "Mortgage Offer Received",
            "weight": 15,
            "value": "04/12/2023",
            "stage": "Reporting",
            "isVisible": true
          },
          {
            "id": "mortgagesent",
            "message": "Mortgage Offer Report Sent",
            "weight": 18,
            "value": "04/12/2023",
            "stage": "Reporting",
            "isVisible": true
          },
          {
            "id": "enquiriesraised",
            "message": "Enquiries Satisfied",
            "weight": 12,
            "value": "10/01/2025",
            "stage": "Pre-Exchange",
            "isVisible": true
          },
          {
            "id": "contractsigned",
            "message": "Received Contract From Client",
            "weight": 20,
            "value": "04/12/2023",
            "stage": "Pre-Exchange",
            "isVisible": true
          },
          {
            "id": "exchangedate",
            "message": "Exchanged",
            "weight": 12,
            "value": null,
            "stage": "Pre-Completion",
            "isVisible": true
          },
          {
            "id": "completiondate",
            "message": "Anticipated Completion",
            "weight": 12,
            "value": null,
            "stage": "Pre-Completion",
            "isVisible": true
          }
        ],
      },
      options: trackerChartOptions?.Purchase
    },
    Sale: {
      details: {
        tracker: [
          {
            "id": "exchanged&completed",
            "message": "Exchanged&Completed",
            "weight": 12,
            "value": null,
            "stage": "Exchanged and Completed",
            "isVisible": true
          },
          {
            "id": "cclsent",
            "message": "Initial Paperwork Sent",
            "weight": 20,
            "value": "16/05/2024",
            "stage": "On-Boarding",
            "isVisible": true
          },
          {
            "id": "cclacceptable",
            "message": "Initial Paperwork Received",
            "weight": 20,
            "value": "16/05/2024",
            "stage": "On-Boarding",
            "isVisible": true
          },
          {
            "id": "fundsvalid",
            "message": "Client Search Monies Received",
            "weight": 20,
            "value": "16/05/2024",
            "stage": "On-Boarding",
            "isVisible": true
          },
          {
            "id": "contractsent",
            "message": "Contract Sent to Client",
            "weight": 20,
            "value": null,
            "stage": "Contracts",
            "isVisible": true
          },
          {
            "id": "contractsreceived",
            "message": "Signed Contract Received from Client",
            "weight": 20,
            "value": null,
            "stage": "Contracts",
            "isVisible": true
          },
          {
            "id": "contractsenttobuyer",
            "message": "Draft Contracts Sent to Buyers Solicitor",
            "weight": 20,
            "value": "16/05/2024",
            "stage": "Contracts",
            "isVisible": true
          },
          {
            "id": "enquiriesreceived",
            "message": "Enquiries Received",
            "weight": 20,
            "value": null,
            "stage": "Dealing With Enquiries",
            "isVisible": true
          },
          {
            "id": "enquiriesreplied",
            "message": "Enquiries Replied To",
            "weight": 20,
            "value": null,
            "stage": "Dealing With Enquiries",
            "isVisible": true
          },
          {
            "id": "exchangedate",
            "message": "Exchanged",
            "weight": 10,
            "value": null,
            "stage": "Pre-Completion",
            "isVisible": true
          },
          {
            "id": "completiondate",
            "message": "Anticipated Completion",
            "weight": 10,
            "value": null,
            "stage": "Pre-Completion",
            "isVisible": true
          }
        ]
      },
      options: trackerChartOptions?.Sale
    },
    Remortgage: {
      details: {
        tracker: [
          {
            "id": "exchanged&completed",
            "message": "Exchanged&Completed",
            "weight": 12,
            "value": null,
            "stage": "Exchanged and Completed",
            "isVisible": true
          },
          {
            "id": "cclsent",
            "message": "Initial Paperwork Sent",
            "weight": 20,
            "value": "19/08/2021",
            "stage": "On-Boarding",
            "isVisible": true
          },
          {
            "id": "cclacceptable",
            "message": "Initial Paperwork Received",
            "weight": 20,
            "value": "14/09/2021",
            "stage": "On-Boarding",
            "isVisible": true
          },
          {
            "id": "deedsrequested",
            "message": "Deeds/Official Copies Requested",
            "weight": 20,
            "value": null,
            "stage": "Title Checking",
            "isVisible": true
          },
          {
            "id": "deedsreceived",
            "message": "Deeds/Official Copies Received",
            "weight": 20,
            "value": null,
            "stage": "Title Checking",
            "isVisible": true
          },
          {
            "id": "mortgagereceived",
            "message": "Mortgage Offer Received",
            "weight": 20,
            "value": "08/09/2021",
            "stage": "Financing",
            "isVisible": true
          },
          {
            "id": "mortgagesent",
            "message": "Mortgage Deed Sent to Client",
            "weight": 20,
            "value": "13/09/2021",
            "stage": "Financing",
            "isVisible": true
          },
          {
            "id": "moniesreceived",
            "message": "Completion Monies Received",
            "weight": 20,
            "value": null,
            "stage": "Financing",
            "isVisible": true
          },
          {
            "id": "cotsentdate",
            "message": "Set-Up",
            "weight": 10,
            "value": "20/12/2021",
            "stage": "Completing",
            "isVisible": true
          },
          {
            "id": "completiondate",
            "message": "Anticipated Completion",
            "weight": 10,
            "value": null,
            "stage": "Completing",
            "isVisible": true
          }
        ]
      },
      options: trackerChartOptions?.Remortgage
    },
    SecuredLending: {
      details: {
        tracker: [
          {
            "id": "LenderInstructionsReceivedDate",
            "message": "Lender Instructions Received",
            "weight": 20,
            "value": "19/08/2021",
            "stage": "Secured Lending",
            "isVisible": true
          },
          {
            "id": "CostsUndertakingReceivedDate",
            "message": "Costs Undertaking Received",
            "weight": 20,
            "value": null,
            "stage": "Secured Lending",
            "isVisible": true
          },
          {
            "id": "RepliestoSchedofReqReceivedDate",
            "message": "Replies to Schedule of Requirements Received",
            "weight": 20,
            "value": "19/08/2021",
            "stage": "Secured Lending",
            "isVisible": true
          },
          {
            "id": "FacilityLetterReceivedDate",
            "message": "Facility Letter Received",
            "weight": 20,
            "value": "19/08/2021",
            "stage": "Secured Lending",
            "isVisible": true
          },
          {
            "id": "SecurityDocumentsIssuedDate",
            "message": "Security Documents Issued",
            "weight": 20,
            "value": null,
            "stage": "Secured Lending",
            "isVisible": true
          },
          {
            "id": "TitleCheckDoneandEnqRaisedDate",
            "message": "Title Check Done and Enquiries Raised",
            "weight": 20,
            "value": null,
            "stage": "Secured Lending",
            "isVisible": true
          },
          {
            "id": "ReponTitleCertofTitleSentDate",
            "message": "Report on Title/Certificate of Title Sent to Lender",
            "weight": 20,
            "value": "19/08/2021",
            "stage": "Secured Lending",
            "isVisible": true
          },
          {
            "id": "FinalReptoEnquiriesReceivedDate",
            "message": "Final Replies to Enquiries Received",
            "weight": 20,
            "value": "19/08/2021",
            "stage": "Secured Lending",
            "isVisible": true
          },
          {
            "id": "SignedSecDocumentsReceivedDate",
            "message": "Signed Security Documents Received",
            "weight": 20,
            "value": null,
            "stage": "Secured Lending",
            "isVisible": true
          },
          {
            "id": "CompleteNowButtonPressedDate",
            "message": "Complete Now Pressed",
            "weight": 20,
            "value": "19/08/2021",
            "stage": "Secured Lending",
            "isVisible": true
          },
        ],
      },
      options: trackerChartOptions?.SecuredLending
    },
  });

  const handleTrackerChartOptions = (caseType: string, clickedItem: string) => {
    const updatedTrackerChartData = {
      ...trackerChartData,
      [caseType]: {
        ...trackerChartData[caseType],
        details: {
          ...trackerChartData[caseType].details,
          tracker: trackerChartData[caseType].details.tracker.map((item) =>
            item.message === clickedItem ? { ...item, isVisible: !item.isVisible } : item
          ),
        },
        options: trackerChartData[caseType].options.map((trackerOptions) => ({
          ...trackerOptions,
          items: trackerOptions.items.map((item) =>
            item.message === clickedItem ? { ...item, isVisible: !item.isVisible } : item
          ),
        })),
      },
    };

    setTrackerChartData(updatedTrackerChartData);
    setTrackerChartChangedIndex(trackerChartChangedIndex + 1);
  };

  const handleUpdateTrackerChartOptions = () => {
    const updatedTrackerChartOptions = {
      Purchase: [...trackerChartData.Purchase.options],
      Sale: [...trackerChartData.Sale.options],
      Remortgage: [...trackerChartData.Remortgage.options],
      SecuredLending: [...trackerChartData.SecuredLending.options],
    }

    const state: Cases.updatedTrackerChartDataState = {
      casekey: cases.user,
      caseType: trackerChartCaseType === "SecuredLending" ? "L" : trackerChartCaseType[0],
      chartData: JSON.stringify(trackerChartCaseType === "Purchase" ? updatedTrackerChartOptions.Purchase : trackerChartCaseType === "Sale" ? updatedTrackerChartOptions.Sale : trackerChartCaseType === "Remortgage" ? updatedTrackerChartOptions.Remortgage : updatedTrackerChartOptions.SecuredLending),
    };
    dispatch(Cases.setLoading(true));
    dispatch(Cases.updateTrackerChartData(state) as unknown as AnyAction).then(() => {
      dispatch(setTrackerChartOptions(updatedTrackerChartOptions));

      cases.cases.forEach((item) => {
        if (item.caseno === cases.case.caseno) {
          const updatedProgressValue = Cases.getProgress(item, item.type as keyof Cases.TrackerChartOptions, updatedTrackerChartOptions);
          const updatedCase = { ...cases.case, details: { ...cases.case.details, progress: updatedProgressValue } };
          dispatch(Cases.setCase(updatedCase) as unknown as AnyAction);
        }
      });

      dispatch(Cases.setLoading(false));
    });
  };

  useEffect(() => {
    setTrackerChartData((prevData) => ({
      ...prevData,
      Purchase: { ...prevData.Purchase, options: cases.trackerChartOptions.Purchase },
      Sale: { ...prevData.Sale, options: cases.trackerChartOptions.Sale },
      Remortgage: { ...prevData.Remortgage, options: cases.trackerChartOptions.Remortgage },
      SecuredLending: { ...prevData.SecuredLending, options: cases.trackerChartOptions.SecuredLending }
    }));
  }, [cases.trackerChartOptions]);

  return (
    <div className="Home">
      <div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
        <div className='OrangeBand'>
          <div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img style={{ width: 96, height: 96, marginRight: 8 }} src={icon_edit_chart} alt='Analytics-Icon' />
              <div style={{ marginLeft: 24 }}>
                <div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Edit Tracker Chart</div>
              </div>
            </div>
          </div>
        </div>

        <div className='editTrackerChartContainer'>
          <div className="editTrackerChartBox">
            <div className="editTrackerChartBoxHeading">
              <h3>Case Type: </h3>
              <select className="trackerChartCaseType" value={trackerChartCaseType} onChange={(e) => setTrackerChartCaseType(e.target.value)}>
                <option value="Purchase">Purchase</option>
                <option value="Sale">Sale</option>
                <option value="Remortgage">Remortgage</option>
                <option value="SecuredLending">Secured Lending</option>
              </select>
            </div>

            <div className="editTrackerChartBoxMain">
              <div className="flexGrow2 trackerChartBox">
                <TrackerChart data={trackerChartData[trackerChartCaseType]} size={458} trackerChartChangedIndex={trackerChartChangedIndex} caseType={trackerChartCaseType} />

                <div style={{ position: 'relative' }}>
                  <div className='trackerChartCustomOptions'>
                    <div className="trackerChartOptionsMain">
                      {trackerChartData[trackerChartCaseType].options?.map((item, index) => (
                        <div className="trackerChartCustomOptionsBox" key={index}>
                          <div className='trackerChartCustomOptionsHeader'>{item.stage}</div>
                          {item.items.map((subItem, subIndex) => (
                            <div className='trackerChartCustomOptionsData' key={subIndex}>
                              <input type="checkbox" checked={subItem.isVisible} style={{ accentColor: subItem.value ? '#7e9d0b' : '#3ca0bd' }} onChange={() => handleTrackerChartOptions(trackerChartCaseType, subItem.message)} />

                              <div style={{ backgroundColor: subItem.value ? '#98C000' : '#4BC0E1' }}>
                                <p>{subItem.message}</p>
                                <p>{subItem.value ?? '-'}</p>
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>

                    <button className='trackerChartCustomOptionsBtn' onClick={handleUpdateTrackerChartOptions}>Update</button>
                  </div>

                  <p className='editTrackerChartHelperText'>Note :- By Clicking "Update", The Changes will be made for all Cases having that Case Type</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='mainFooter'>
        <div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
          <img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
        </div>
      </div>

      <div className='loginFooter'></div>
      <NavMenu />
      <NavBar />
    </div>
  )
}

export default EditTrackerChart;